<script lang="ts">
export default {
  name: 'KkSearchForm',
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { KkIcon } from '../../../components/base'

interface Props {
  modelValue?: string;
  disabled?: boolean;
  width?: string;
  height?: string;
  placeholder?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  disabled: false,
  width: '240px',
  height: '42px',
  placeholder: '検索'
})

interface Emits {
  (event: 'update:modelValue', value: string): void;
  (event: 'search'): void;
}

const emits = defineEmits<Emits>()

const searchStyled = computed(() => {
  const styles: Record<string, string> = {}
  styles['width'] = props.width
  styles['height'] = props.height
  return styles
})

const handleInput = ($event: Event) => {
  const target = $event.target as HTMLInputElement
  emits('update:modelValue', target.value)
}
const search = ()=> {
  emits('search')
}
</script>
<template>
  <div class="c-searchField">
    <input
      :value="modelValue"
      :disabled="props.disabled"
      type="text"
      class="searchForm"
      :placeholder="props.placeholder"
      :style="searchStyled"
      @keydown.enter="search"
      @input="handleInput($event)"
    >
    <KkIcon name="search" class="icon" />
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';
.icon {
  width: 16px;
}
</style>
